import { render, staticRenderFns } from "./v-work-list.vue?vue&type=template&id=05565e35&scoped=true"
import script from "./v-work-list.vue?vue&type=script&lang=js"
export * from "./v-work-list.vue?vue&type=script&lang=js"
import style0 from "./v-work-list.vue?vue&type=style&index=0&id=05565e35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05565e35",
  null
  
)

export default component.exports